import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment } from '@mui/material'
import TextField from '@mui/material/TextField'
import withStyles from '@mui/styles/withStyles'
import React, { useCallback, useEffect, useState } from 'react'
import Button from 'Theme/Button'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

const Styles = withStyles((theme) => ({
  root: {
    borderRadius: theme.spacing(0.75),
  },
}))

const SearchField = ({
  classes,
  id,
  placeholder,
  value: rawValue,
  onChange,
  endAdornment,
  allowClear,
  isMobile,
  ...props
}) => {
  const [value, setValue] = useState(rawValue)

  const handleChange = useCallback(
    (event) => {
      setValue(event.target.value)
      onChange && onChange(event.target.value)
    },
    [onChange],
  )

  useEffect(() => {
    setValue(rawValue)
  }, [rawValue])

  const handleClear = useCallback(() => {
    setValue('')
    onChange('')
  }, [onChange])

  return (
    <TextField
      id={id}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      classes={classes}
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon htmlColor="#9298AA" />
          </InputAdornment>
        ),
        endAdornment:
          allowClear && value ? (
            isMobile ? (
              <Button sx={{ padding: '0 !important', minWidth: 'unset' }}>
                <FAIcon
                  iconClassName={FA_ICONS.CIRCLE_XMARK}
                  color="#9298AA"
                  onClick={handleClear}
                />
              </Button>
            ) : (
              <Button
                variant="text"
                color="secondary"
                className={classes.clearButton}
                onClick={handleClear}
              >
                Clear
              </Button>
            )
          ) : null,
        classes: classes,
      }}
      {...props}
    />
  )
}

export default Styles(SearchField)
